import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css"; // Keep basic CSS reset/global styles
import App from "./App";
import { AuthProvider } from "./context/AuthContext"; // Import AuthProvider
import "@fortawesome/fontawesome-free/css/all.min.css";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <AuthProvider>
    {" "}
    {/* Wrap App with AuthProvider */}
    <App />
  </AuthProvider>
);
